import { z } from "zod";

const customExtendSessionSchema = z.object({
  minutes: z
    .union([z.string().transform((val) => parseInt(val, 10)), z.number()])
    .refine((val) => val >= 1, "Minutes must be at least 1"),
});
type CustomExtendSessionFormData = z.infer<typeof customExtendSessionSchema>;

export { customExtendSessionSchema };
export type { CustomExtendSessionFormData };
